import { render, staticRenderFns } from "./ListRewardCategory.vue?vue&type=template&id=19cb413c&scoped=true"
import script from "./ListRewardCategory.vue?vue&type=script&lang=js"
export * from "./ListRewardCategory.vue?vue&type=script&lang=js"
import style0 from "./ListRewardCategory.vue?vue&type=style&index=0&id=19cb413c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cb413c",
  null
  
)

export default component.exports